import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  IconDefinition,
} from "@fortawesome/sharp-regular-svg-icons";
import classNames from "classnames";
import { Button, Menu } from "@mantine/core";
import { kebabCase } from "lodash";

import styles from "./meatball-menu.module.scss";

type MenuBaseAction = {
  label: string;
  icon?: IconDefinition;
};

type MenuLinkAction = MenuBaseAction & {
  as: "a";
  href: string;
  target?: "_blank";
};

type MenuButtonAction = MenuBaseAction & {
  onClick: () => void;
  as?: "button";
};

type MeatballMenuProps = {
  className?: string;
  actions: (MenuButtonAction | MenuLinkAction)[];
  keyPrefix?: string;
  buttonAriaLabel?: string;
  disabled?: boolean;
};

export const MeatballMenu = ({
  className,
  actions,
  keyPrefix = "",
  buttonAriaLabel,
  disabled,
}: MeatballMenuProps) => (
  <Menu position="bottom-end" width={140} disabled={disabled}>
    <Menu.Target>
      <Button
        type="button"
        className={classNames(styles.meatballButton, className)}
        aria-label={buttonAriaLabel}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </Button>
    </Menu.Target>
    <Menu.Dropdown className={styles.dropdown}>
      {actions.map((action) => (
        <Menu.Item
          component={action.as ?? "button"}
          key={
            keyPrefix
              ? `${keyPrefix}-${kebabCase(action.label)}`
              : kebabCase(action.label)
          }
          onClick={action.as !== "a" ? action.onClick : undefined}
          href={action.as === "a" ? action.href : undefined}
          target={action.as === "a" ? action.target : undefined}
          classNames={{
            item: styles.menuItem,
            itemLabel: styles.menuItemLabel,
          }}
        >
          {action.label}
          {action.icon && (
            <div className={styles.menuItemIconContainer}>
              <FontAwesomeIcon size="sm" icon={action.icon} />
            </div>
          )}
        </Menu.Item>
      ))}
    </Menu.Dropdown>
  </Menu>
);
